export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.melding = item != null ? item.melding : ''
        this.reactie = item != null ? item.reactie : ''
        this.documentId = item != null ? item.documentId : ''
        this.klantId = item != null ? item.klantId : ''
        this.triggerId = item != null ? item.triggerId : ''
        this.username = item != null ? item.username : ''
        this.meldingTijd = item != null ? item.meldingTijd : ''
        this.filename = item != null ? item.document.filename : ''
        this.factuurnummer = item != null ? item.factuurnummer : ''
        this.factuurdatum = item != null ? item.factuurdatum : ''
        this.referentie = item != null ? item.referentie : ''
        this.totaalbedrag = item != null ? item.totaalbedrag : ''
        this.subtotaal = item != null ? item.subtotaal : ''
        this.btwLaag = item != null ? item.btwLaag : ''
        this.btwHoog = item != null ? item.btwHoog : ''
        this.btwNul = item != null ? item.btwNul : ''
        this.kostenLaag = item != null ? item.kostenLaag : ''
        this.kostenHoog = item != null ? item.kostenHoog : ''
        this.kostenNul = item != null ? item.kostenNul : ''
        this.kostenVerlegd = item != null ? item.kostenVerlegd : ''
    }
}